<!--商品列表-->
<template>
  <div>
    <HeadSearch></HeadSearch>
    <div style="height:1rem"></div>

    <div class="goods-list-box">
      <div
        v-for="(item,index) in cate_list"
        :key="index"
        class="cate-items"
        @click="onNavClick(item)"
      >
        <img mode="widthFix" :src="item.pic_url" />
        <div style="font-size:12px;color:#333;margin-top:10px">{{item.name}}</div>
      </div>
    </div>
    <van-sticky :offset-top="40">
      <div class="goods-type">
        <div class="box" style="margin-top:0.2rem">
          <van-tabs
            v-model="active"
            line-height="0"
            class="tabs_"
            :line-width="width"
            @click="getCateGoods"
          >
            <van-tab v-for="(item,i) in cate_list" :key="item.id" class="tab_">
              <template slot="title">
                <div class="tagname show-one-row">{{item.name}}</div>
                <div
                  :class="active==i ? 'sname-change show-one-row':'sname show-one-row' "
                >{{item.sname}}</div>
              </template>
              <!-- <div v-for="(goods,i) in item.list"> -->
              <!-- <goodsItem1 :goodsList="item.list"></goodsItem1> -->
              <!-- </div> -->
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <!--<div v-if="!goods.length">
                    暂无数据~~
        </div>-->
        <div class="goods-list">
          <GoodsItems :goodsList="goods"></GoodsItems>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<style scoped>
.goods-list-box {
  display: flex;
  flex-wrap: wrap;
}

.cate-items {
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.cate-items img {
  width: 49px;
  height: 49px;
}

.show-one-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.box >>> .van-tab__text {
  width: 100%;
}

.box >>> .van-tabs__line {
  background-color: none !important;
}

.box >>> .van-tabs__nav {
  background: none;
}

.box >>> .van-hairline--top-bottom::after,
.box >>> .van-hairline-unset--top-bottom::after {
  border: none !important;
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: none !important;
}

.tagname {
  height: 16px;
  font-size: 16px;
  font-family: PingFang;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  line-height: 16px;
  text-align: center;
  /* overflow: hidden; */
}

.sname-change {
  height: 22px;
  background: rgba(250, 74, 85, 1);
  border-radius: 10px;
  color: #fff;
  margin-top: 4px;
  line-height: 22px;
  padding: 0 5px;
  text-align: center;
}

.sname {
  height: 22px;
  border-radius: 10px;
  color: #999999;
  margin-top: 4px;
  line-height: 22px;
  padding: 0 5px;
  text-align: center;
}

.goods-type {
  width: 100%;
  background: #fff;
  z-index: 10;
}

.van-tabs--line .van-tabs__wrap {
  top: 100px;
}

.van-tabs--line {
  /*top:50px*/
}

.goods-list {
  padding-top: 0.4rem;
}

/*.van-pull-refresh {
      padding-top: 2rem;
    }*/
</style>

<script>
import Vue from "vue";
import HeadSearch from "@/components/HeadSearch.vue";
import GoodsItems from "@/components/GoodsItem1.vue";
import { Tab, Tabs, PullRefresh, List, Search, Sticky } from "vant";

Vue.use(Sticky);
export default {
  name: "GoodsList",
  components: {
    HeadSearch,
    GoodsItems,
    Tab,
    Tabs,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Search.name]: Search
  },
  data: function() {
    return {
      goods: [],
      cate_list: [],
      params: {
        parent_cate_id: 0,
        cate_id: 0,
        p: 1,
        step: 10
      },
      isLoading: false,
      loading: false,
      finished: false,

      width: 70,
      homeTop: 0,
      active: 0
    };
  },
  filter: {},
  activated() {
    let that = this;
    document.title = "商品列表";

    if (!this.$route.meta.isBack) {
      // 清空查询条件和数据
      that.goods = [];
      that.active = 0;
      that.params.p = 1;
      that.loading = true;
      that.finished = false;
      that.getGoodsList();
    }
    this.$route.meta.isBack = false;
    this.params.cate_id = this.params.parent_cate_id = this.$route.query.cate_id;

    document.getElementById("app").scrollTop = this.homeTop || 0;
  },
  mounted() {
    let that = this;
    that.getGoodsList();
  },
  destroyed() {},
  beforeRouteEnter(to, from, next) {
    console.log(from.path);
    if (from.path == "/goodsdetail" || from.path == "/shopgoodsdetail") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }

    next();
  },

  // 获取上拉数据
  methods: {
    getGoodsList(ref) {
      let that = this;

      // console.log(this.params.cate_id)
      this.$api.get("/api/goods/goodsList1", that.params, res => {
        // console.log(res)
        // console.log(that.params)
        that.loading = false;

        if (that.params.p == 1) {
          that.cate_list = res.data.cate_list;
        }

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          if (ref) {
            that.$toast("刷新成功");
          }

          that.goods = res.data.list;
        } else {
          let list = that.goods.concat(res.data.list);

          that.goods = list;
        }
        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.p += 1;
      });
    },

    // 获取分类商品
    getCateGoods(index) {
      // console.log(index)
      let that = this;
      // that.params.cate_id = index;
      console.log(that.cate_list, index);
      that.params.cate_id = that.cate_list[index].id;

      // console.log(that.params.cate_id); return
      that.params.p = 1;

      // 激活下拉
      that.finished = false;

      // console.log(that.loading)
      // true ??
      that.loading = true;

      // 将商品数据赋空
      that.goods = [];
      that.getGoodsList();
    },

    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.getGoodsList();
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      that.getGoodsList(1);
    },
    onNavClick(item) {
      rbLink({
        name: "GoodsList2",
        query: {
          cate_id: item.id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// GoodsList.vue?706eaad2